var classes = {"videoWrapper":"_9E7yp","video":"RtGAn","videoOverlayIcon":"fL19D","videoControlsIcon":"YQafc","videoControlsContainer":"HfuXK","videoControlsPlayback":"C3QfO","videoControlsVolume":"-gbIP","videoControlRangeContainer":"_3r-Zs","videoControlRange":"rAaFo","videoControlRangeProgress":"z-i95","videoControlOverlay":"rWoPA"};

export { classes as default };
